/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export const EVALUATIONS_STRINGS = {
  list: {
    loading: 'Loading evaluations...',
    loadErrorTitle: 'Could not load evaluations',
    retry: 'Retry',
    noMatchesTitle: 'No repositories match the filters',
    noMatchesDescription: 'Try changing or clearing the filters.',
    clearFilters: 'Clear filters',
    emptyTitle: 'No repositories evaluated yet',
    emptyDescription:
      'Firewall has not evaluated any repository yet. The proxy repositories of this instance appear here once Firewall has evaluated them.',
    noResults: 'No results',
    pageEmptyTitle: 'No results on this page',
    pageEmptyDescription: 'This page is past the last page of results.',
    firstPage: 'Go to first page',
    searchLabel: 'Search repositories',
    searchPlaceholder: 'Search by repository name',
    filtersLabel: 'Evaluations filters',
    resultsLabel: 'Evaluations results',
    tableCaption: 'Repository evaluations',
  },
  columns: {
    repository: 'Repository',
    format: 'Format',
    quarantine: 'Quarantine',
    lastEvaluation: 'Last evaluation',
    componentsEvaluated: 'Components evaluated',
    critical: 'Critical',
    severe: 'Severe',
    moderate: 'Moderate',
    quarantined: 'Quarantined',
  },
  filters: {
    format: 'Format',
    threatLevel: 'Threat level',
    violations: 'Violations',
    withViolations: 'With violations',
    withoutViolations: 'Without violations',
  },
  threatLevels: {
    critical: 'Critical',
    severe: 'Severe',
    moderate: 'Moderate',
  },
  values: {
    yes: 'Yes',
    no: 'No',
    neverEvaluated: 'Never evaluated',
    inProgress: 'In progress',
  },
  errors: {
    loadList: 'Failed to load evaluations.',
  },
  reevaluate: {
    button: 'Re-evaluate',
    buttonLabel: (name: string) => `Re-evaluate Repository ${name}`,
    actionsColumn: 'Actions',
    confirm: {
      title: 'Re-evaluate Repository',
      body: (name: string) =>
        `Re-evaluate all components of ${name}? This can take several minutes for large repositories.`,
      confirmLabel: 'Re-evaluate',
      cancelLabel: 'Cancel',
    },
    started: 'Re-evaluation started',
    completed: 'Re-evaluation completed',
    failed: 'The re-evaluation failed',
    skipped: 'IQ Server skipped the re-evaluation',
    finished: 'The re-evaluation finished',
    alreadyRunning: 'A re-evaluation of this repository is already running',
    errors: {
      start: 'Could not start the re-evaluation',
      poll: 'Could not read the re-evaluation status',
    },
  },
  repositoriesCount: (total: number) => `${total.toLocaleString()} ${total === 1 ? 'repository' : 'repositories'}`,
  repositoriesFiltered: (filtered: number, total: number) =>
    `${filtered.toLocaleString()} of ${total.toLocaleString()} repositories`,
  results: (total: number) => `${total.toLocaleString()} ${total === 1 ? 'result' : 'results'}`,
  countTitle: (count: number, label: string) => `${count.toLocaleString()} ${label}`,
};
